import { JSX } from 'react'

import { IconProps } from '../../icon'

const User: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M25 8C16.1713 8 9 15.1713 9 24C9 32.8287 16.1713 40 25 40C33.8287 40 41 32.8287 41 24C41 15.1713 33.8287 8 25 8ZM17.9272 35.52C19.5354 33.2062 22.1774 31.7949 25 31.7949C27.8226 31.7949 30.4646 33.1897 32.0892 35.52C30.0215 36.8 27.6092 37.5385 25 37.5385C22.3908 37.5385 19.9949 36.8 17.9272 35.52ZM34.0421 34.0431C31.9579 31.0892 28.6103 29.3333 25 29.3333C21.3897 29.3333 18.0256 31.1221 15.9579 34.0431C13.201 31.5651 11.4615 27.9877 11.4615 24C11.4615 16.5333 17.5333 10.4615 25 10.4615C32.4667 10.4615 38.5385 16.5333 38.5385 24C38.5385 27.9877 36.799 31.5651 34.0421 34.0431Z'
      fill='black'
    />
    <path
      d='M25 14.5641C21.6031 14.5641 18.8462 17.321 18.8462 20.7179C18.8462 24.1149 21.6031 26.8718 25 26.8718C28.3969 26.8718 31.1539 24.1149 31.1539 20.7179C31.1539 17.321 28.3969 14.5641 25 14.5641ZM25 24.4103C22.9651 24.4103 21.3077 22.7528 21.3077 20.7179C21.3077 18.6831 22.9651 17.0256 25 17.0256C27.0349 17.0256 28.6923 18.6831 28.6923 20.7179C28.6923 22.7528 27.0349 24.4103 25 24.4103Z'
      fill='black'
    />
  </svg>
)

export default User
